module.exports = __webpack_public_path__ + "static/media/nz.01e1e398.svg";